// extracted by mini-css-extract-plugin
module.exports = {"marketing-ribbon-container":"Marketing-Ribbon_marketing-ribbon-container__5SV_f"};